import { combineReducers } from 'redux';

import orgs from './orgs';
import orgProducts from './orgProducts';
import orgUsers from './orgUsers';
import users from './users';
import products from './products';
import roles from './roles';

const reducers = combineReducers({
  orgs,
  orgProducts,
  orgUsers,
  users,
  products,
  roles,
});

export default reducers;
